import { render } from "./CharacterTable.vue?vue&type=template&id=4b1808d6&scoped=true"
import script from "./CharacterTable.vue?vue&type=script&lang=js"
export * from "./CharacterTable.vue?vue&type=script&lang=js"

import "./CharacterTable.vue?vue&type=style&index=0&id=4b1808d6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1808d6"]])

export default __exports__